import { motion, HTMLMotionProps } from "framer-motion";
import { ReactNode } from "react";
import { cn } from "../../utils/helpers";

// FIX: Extend HTMLMotionProps<"div">
interface CardProps extends HTMLMotionProps<"div"> {
  children: ReactNode;
  noPadding?: boolean;
  variant?: "default" | "glass" | "neon";
}

export const Card = ({
  children,
  className,
  noPadding = false,
  variant = "default",
  ...props
}: CardProps) => {
  const variants = {
    default:
      "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 shadow-sm",
    glass:
      "bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-white/40 dark:border-white/10 shadow-xl",
    neon: "bg-slate-950 border-indigo-500/30 shadow-[0_0_30px_rgba(99,102,241,0.1)]",
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={cn(
        "relative rounded-2xl border overflow-hidden transition-all duration-300 group",
        variants[variant],
        !noPadding && "p-6",
        className,
      )}
      {...props}
    >
      {/* Noise Texture for premium feel */}
      <div
        className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05] pointer-events-none z-0 mix-blend-overlay"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Content wrapper to sit above noise */}
      <div className="relative z-10 h-full">{children}</div>
    </motion.div>
  );
};
